import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { DataBagService } from 'src/app/common/data-bag.service';
import { TableElement } from 'src/app/www/www-menu/www-menu.component';

import { FormControl, Validators } from '@angular/forms';
import { FormBuilder, FormArray } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { BagPaymentListProfileAddComponent } from './bag-payment-list-profile-add/bag-payment-list-profile-add.component';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { BagPaymentListService } from '../../bag-payment-list.service';
import { DateService } from 'src/app/common/date.service';

@Component({
	selector: 'app-bag-payment-list-add-modal',
	templateUrl: './bag-payment-list-add-modal.component.html',
	styleUrls: ['./bag-payment-list-add-modal.component.scss'],
})
export class BagPaymentListAddModalComponent implements OnInit, OnDestroy {
	@ViewChild('dataTable') dataTable: MatTable<any>;
	@ViewChild('accountTable') accountTable: MatTable<any>;
	selectedAccount = null;
	loading = false;
	submitted = false;
	showColumns = [
		'tableId',
		'userData',
		'amount',
		'payment',
		'bankAccountIncoming',
		'invoiceNumber',
		'note',
		'delete',
	];
	optionTable = new MatTableDataSource<TableElement>();
	filteredBankAccountPosting: any[];
	filteredUsers: any[];
	filteredReservationObj: any[];
	reservationObj: any[];
	constructor(
		public dialogRef: MatDialogRef<BagPaymentListAddModalComponent>,
		@Inject(MAT_DIALOG_DATA)
		public dialogData: any,
		protected bag: DataBagService,
		protected loader: LoaderService,
		protected infobox: InfoboxService,
		protected fb: FormBuilder,
		public dialog: MatDialog,
		private readonly _service: BagPaymentListService,
		protected date: DateService,
	) {}

	form = this.fb.group({
		bankAccountPosting: ['', Validators.required],
		posting: ['', Validators.required],
		payments: this.fb.array([]),
	});

	protected addPos(): void {
		const paymentRow: any = this.fb.group({
			tableId: new FormControl(null, [Validators.required, Validators.minLength(3)]),
			userData: new FormControl(null, [Validators.required]),
			amount: new FormControl(null, [Validators.required]),
			kind: 'transfer',
			organization: null,
			bankAccountIncoming: new FormControl(null, [Validators.required]),
			invoiceNumber: null,
			status: 'CO',
			currency: 1,
			payment: new FormControl(null, [Validators.required]),
			posting: new FormControl(null, [Validators.required]),
			table_name: 'reservation_reservation',
			note: '',
		});
		this.payments.push(paymentRow);
		this.dataTable.renderRows();
		this.payments.controls.forEach((control) => {
			control['controls'].userData.valueChanges
				.pipe(
					startWith(''),
					debounceTime(400),
					map((value) => this._filterUsers(value || '')),
				)
				.subscribe((filtered) => {
					this.filteredUsers = filtered;
				});
			control['controls'].tableId.valueChanges
				.pipe(
					debounceTime(900),
					distinctUntilChanged(),
					map((value) => this._filterReservationObj(value || '', control)),
				)
				.subscribe((filtered) => {
					if (filtered !== undefined) {
						this.reservationObj = [];
					}
				});
		});
	}

	clearOwnerUser(control) {
		this.payments.at(this.payments.controls.indexOf(control)).get('userData').setValue(null);
		return control;
	}

	setOwnerUser(control) {
		this.loader.show();
		this.bag.get(`/reservation/list_filter/?q=${control['controls'].tableId.value}`, (result, error) => {
			if (result.results.length === 0) return this.loader.hide();
			this.payments
				.at(this.payments.controls.indexOf(control))
				.get('userData')
				.setValue(result.results[0].ownerUser?.id);
			this.loader.hide();
		});
	}

	get payments() {
		return this.form.controls['payments'] as FormArray;
	}

	get paymentsControl() {
		return this.form.get('payments') as FormArray;
	}

	ngOnInit() {
		this.form.controls.bankAccountPosting.valueChanges
			.pipe(
				startWith(''),
				debounceTime(400),
				map((value) => this._filterAccount(value || '')),
			)
			.subscribe((filtered) => {
				this.filteredBankAccountPosting = filtered;
			});
		this._service.users.subscribe((data) => {
			this.dialogData['profileData'] = data;
		});
	}

	ngOnDestroy(): void {
		this._service.users.unsubscribe();
	}

	private _filterAccount(value: any) {
		if (value && typeof value === 'string') {
			const filterValue = value.toLowerCase();

			if (filterValue.length < 3) return this.dialogData['bankAccounts'];

			return this.dialogData['bankAccounts'].filter(
				(option) =>
					option.organization?.shortName.toLowerCase().includes(filterValue) ||
					option.number.toLowerCase().includes(filterValue),
			);
		}
		return this.dialogData['bankAccounts'];
	}

	private _filterReservationObj(value: any, control) {
		if (value && typeof value === 'string') {
			this.loader.show();
			if (value && typeof value === 'string') {
				this.bag.get(`/reservation/list_filter/?q=${value}`, (result, error) => {
					this.reservationObj = result.results;
					this.setOwnerUser(control);
					this.loader.hide();
				});
			}
		}
		return this.reservationObj;
	}

	private _filterUsers(value: any) {
		if (value && typeof value === 'string') {
			const filterValue = value.toLowerCase();

			if (filterValue.length < 3) return this.dialogData['profileData'];

			return this.dialogData['profileData'].filter(
				(option) =>
					option.firstName.toLowerCase().includes(filterValue) ||
					option.lastName.toLowerCase().includes(filterValue),
			);
		}
		return this.dialogData['profileData'];
	}

	displayFn(item: any): string {
		const account = this.dialogData['bankAccounts']?.find((v) => v.id === item);
		return item ? account?.organization?.shortName + ' ' + account?.number : '';
	}

	displayUserProfile(item: any): string {
		const profile = this.dialogData['profileData']?.find((v) => v.id === item);
		return profile ? profile?.firstName + ' ' + profile?.lastName : '';
	}

	displayReservationObj(item: any): string {
		const reservation = this.reservationObj?.find((v) => v.id === item);
		return reservation
			? reservation.id + ' | ' + reservation?.ownerUser?.firstName + ' ' + reservation?.ownerUser?.lastName
			: '';
	}

	selectOption($event: MatAutocompleteSelectedEvent) {
		return $event.option.value;
	}

	protected save() {
		this.submitted = true;
		if (!this.payments.valid) return this.infobox.error('Uzupełnij wymagane pola');
		const data = [];
		this.payments.controls.forEach((control) => {
			control.value.bankAccountPosting = this.form.value.bankAccountPosting;
			control.value.posting = this.date.apiToDateTime(this.form.value.posting).date;
			control.value.payment = this.date.apiToDateTime(control.value.payment).date;
			control.value.amount = this.apiToAmount(control.value.amount);
			data.push(control.value);
		});
		if (data.length === 0) return;
		this.send(data);
	}

	protected apiToAmount(value: number): string {
		return (value * 100).toFixed(0);
	}

	send(data) {
		this.bag.post(`/payment/`, data, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.dialogRef.close('send');
		});
	}

	protected onNoClick(): void {
		this.dialogRef.close();
	}

	protected removeRow(paymentIndex: number): void {
		this.payments.removeAt(paymentIndex);
		this.dataTable.renderRows();
	}

	changeOwner() {
		const dialogRef = this.dialog
			?.open(BagPaymentListProfileAddComponent)
			.afterClosed()
			.subscribe(() => {
				dialogRef?.unsubscribe();
			});
	}
}
